import { render } from "./CookiesUserCard.vue?vue&type=template&id=2c23ce2c&scoped=true"
import script from "./CookiesUserCard.vue?vue&type=script&lang=js"
export * from "./CookiesUserCard.vue?vue&type=script&lang=js"

import "./CookiesUserCard.vue?vue&type=style&index=0&id=2c23ce2c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c23ce2c"]])

export default __exports__